import {
  getPrimaryAccount,
  getAccountData,
  isGeminiUser
} from '../../../../utils/sessionUtil';
import { startDate, todayDate } from '../../../../utils/commonUtil';

export const getContributionApi = () => {

  const userData = getAccountData();
  
  const MOCK_API_URLS = {
    metaData: [
      {
        // account details
        method: 'GET',
        url: '/vceptpl/api/contribution/account/details',
        page: 'contributionsDashboard'
      },
      {
        method: 'GET', // ytd
        url: '/vcetpl/api/account/getYtdForAccount',
        page: 'contributionsDashboard'
      },
      {
        method: 'GET', //pending
        url: `/vceptpl/api/pendingContributions`,
        page: 'contributionsDashboard'
      },
      {
        method: 'GET', // completed
        url: `/vceptpl/api/completedContributions`,
        page: 'contributionsDashboard'
      },
      {
        method: 'GET', // tax receipts
        url: `/vceptpl/api/taxReceipts`,
        page: 'contributionsDashboard'
      },
      {
        method: 'GET', // graph
        url: `/vceptpl/api/contribution/:accountId/findByAccountIdStartDateAndEndDate`,
        page: 'contributionDashboard'
      },
      {
        method: 'GET', // graph
        url: `/vceptpl/api/all/:accountId/findByAccountIdStartDateAndEndDate`,
        page: 'contributionDashboard'
      },
      {
        method: 'GET', // value your contributions
        url: `/value-your-contribution`,
        page: 'contributionDashboard'
      },
      {
        // account established date
        method: 'GET',
        url: `/donor-portal/api/account/userId/findAdditionalAccountDetails${isGeminiUser() === true ? `?partyId=${userData.partyId}`: ''}`,
        page: 'contributionsDashboard'
      }
    ]
  };

  const API_URLS = {
    metaData: [
      {
        method: 'GET', // account details
        url: `/donor-portal/api/investment/${
          getPrimaryAccount().userId
        }/findInvestmentSummaryByAccountIdStartDateAndEndDate?startDateStr=${startDate(
          90
        )}&endDateStr=${todayDate()}`,
        page: 'contributionDashboard'
      },
      {
        method: 'GET', // ytd
        url: `/donor-portal/api/account/${
          getPrimaryAccount().userId
        }/getYtdForAccount?type=C`,
        page: 'contributionDashboard'
      },
      {
        method: 'POST', // pending
        url: `/donor-portal/api/contribution/${
          getPrimaryAccount().userId
        }/findByAccountIdStartDateEndDateAndType`,
        page: 'contributionsDashboard',
        data: {
          accountId: `${getPrimaryAccount().userId}`,
          startDateStr: `${startDate(90)}`,
          endDateStr: todayDate(),
          type: 'PENDING',
          pageSize: '10'
        }
      },
      {
        method: 'POST', // completed
        url: `/donor-portal/api/contribution/${
          getPrimaryAccount().userId
        }/findByAccountIdStartDateEndDateAndType`,
        page: 'contributionsDashboard',
        data: {
          accountId: `${getPrimaryAccount().userId}`,
          startDateStr: `${startDate(90)}`,
          endDateStr: todayDate(),
          type: 'COMPLETED',
          pageSize: '10'
        }
      },
      {
        method: 'GET', // tax receipts
        url: `/donor-portal/api/account/${
          getPrimaryAccount().userId
        }/getAccountDocumentsByAccountIdAndPartyIdAndType/${
          userData.partyId
        }?startDateStr=10/04/1970&endDateStr=${todayDate()}&type=Contributions`,
        page: 'contributionsDashboard'
      },
      {
        method: 'GET', // graph
        url: `/donor-portal/api/contribution/${
          getPrimaryAccount().userId
        }/findByAccountIdStartDateAndEndDate?startDateStr=${startDate(
          368
        )}&endDateStr=${todayDate()}`,
        page: 'contributionDashboard'
      },
      {
        method: 'GET', // graph
        url: `/donor-portal/api/contribution/${
          getPrimaryAccount().userId
        }/findByAccountIdStartDateAndEndDate?startDateStr=${startDate(
          1827
        )}&endDateStr=${todayDate()}`,
        page: 'contributionDashboard'
      },
      {
        method: 'GET', // value your contributions
        url: `/value-your-contribution`,
        page: 'contributionDashboard'
      }
    ]
  };
  if (process.env.REACT_APP_NODE_ENV === 'development') return MOCK_API_URLS;
  return API_URLS;
};
